export default state => ({
  ...state,
  isLoading: false,
});
